import { useFormik } from "formik";
import React from "react";
import { FaComment, FaEnvelope, FaUser } from "react-icons/fa";
import { Button, Form, FormFeedback, FormGroup, Input, Label } from "reactstrap";
import * as Yup from "yup";

const ContactForm = () => {
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email address").required("Email is required"),
    message: Yup.string().required("Message is required"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      message: "",
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      resetForm();
    },
  });
  return (
    <Form className='auth-form' onSubmit={formik.handleSubmit}>
      <div className='form-group'>
        <Label>Name</Label>
        <FaUser className='icon-setting' />
        <Input type='text' name='name' id='exampleInputName1' placeholder='User name' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.name} invalid={formik.touched.name && !!formik.errors.name} />
        {formik.touched.name && formik.errors.name ? <FormFeedback>{formik.errors.name}</FormFeedback> : null}
      </div>
      <div className='form-group'>
        <Label>Email</Label>
        <FaEnvelope className='icon-setting' />
        <Input type='email' name='email' id='exampleInputEmail12' placeholder='Email' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.email} invalid={formik.touched.email && !!formik.errors.email} />
        {formik.touched.email && formik.errors.email ? <FormFeedback>{formik.errors.email}</FormFeedback> : null}
      </div>
      <div className='form-group'>
        <Label>Your message</Label>
        <FaComment className='icon-setting' />
        <Input type='textarea' name='message' id='message' rows='10' placeholder='Your Message' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.message} invalid={formik.touched.message && !!formik.errors.message} />
        {formik.touched.message && formik.errors.message ? <FormFeedback>{formik.errors.message}</FormFeedback> : null}
      </div>
      <FormGroup className='mb-0'>
        <Button className='btn-theme' color=''>
          Send Message
        </Button>
      </FormGroup>
    </Form>
  );
};
export default ContactForm;
